export default "__VITE_ASSET__6aae322a__"